const chatUserIdData = (state = -1, action) => {
    switch(action.type){
        case 'CURRENT_CHAT_USER_ID_INSERT':
            state = action.payload;  
            return state; 
        case 'CURRENT_CHAT_USER_ID_DELETE':
              return state - 1; 
        case 'CURRENT_CHAT_USERID':
              return state; 
        default:
              return state;

    }
};

export default chatUserIdData;